import React from 'react';

export default function SearchBar({value='', onChange}) {
  return (
    <input
      className="input"
      placeholder="Search games, genres, authors..."
      value={value}
      onChange={e => onChange(e.target.value)}
      aria-label="Search reviews"
    />
  );
}
